import type { Certification } from "@/features/workers/types";

export const NEAR_EXPIRY_DAYS = 30;

export function permitDaysRemaining(expiresOn: string | null): number | null {
  if (!expiresOn) return null;
  const expires = new Date(expiresOn).getTime();
  return Math.floor((expires - Date.now()) / 86_400_000);
}

export function certTone(cert: Certification): {
  label: string;
  classes: string;
} {
  if (!cert.expires_on) {
    return {
      label: "no expiry",
      classes: "bg-surface-sunken text-copy-muted border-border",
    };
  }
  const expires = new Date(cert.expires_on).getTime();
  const days = Math.floor((expires - Date.now()) / 86_400_000);
  if (days < 0) {
    return {
      label: `expired ${cert.expires_on}`,
      classes: "bg-destructive-light text-destructive-foreground border-destructive",
    };
  }
  if (days <= 30) {
    return {
      label: `expires ${cert.expires_on}`,
      classes: "bg-warning-light text-warning-foreground border-warning",
    };
  }
  return {
    label: `expires ${cert.expires_on}`,
    classes: "bg-success-light text-success-foreground border-success",
  };
}
